import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, options, references } from '@apexdesigner/schema-tools';

export const curriculum = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    name: z.string().nullable().optional().describe('Name'),

    shortName: z.string().nullable().optional().describe('Short Name'),

    numberOfSessions: z
      .number()
      .nullable()
      .optional()
      .describe('Number Of Sessions'),

    sessionType: options([
      { value: 'In Person', name: 'In Person' },
      { value: 'Online', name: 'Online' },
    ])
      .nullable()
      .optional()
      .describe('Session Type'),

    locked: z.boolean().nullable().optional().hidden().describe('locked'),

    uuid: z.string().nullable().optional().hidden().describe('uuid'),

    version: z.number().nullable().optional().hidden().describe('version'),

    status: z.string().nullable().optional().hidden().describe('status'),

    createdAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('createdAt'),

    publishedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('publishedAt'),

    archivedAt: z.coerce
      .date()
      .nullable()
      .optional()
      .hidden()
      .describe('archivedAt'),

    createdById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    publishedById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    archivedById: z
      .number()
      .nullable()
      .optional()
      .presentAs('reference')
      .describe('Foreign key to User'),

    activities: hasMany('Activity'),

    prescriptions: hasMany('Prescription'),

    sessions: hasMany('Session'),

    createdBy: references('User'),

    publishedBy: references('User'),

    archivedBy: references('User'),
  })
  .describe('A versioned course of study made up of activities.')
  .as('Curriculum');

export { curriculum as curriculumSchema };
